import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Airtable = (props: TIconProps): ReactElement => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.2706 0.622256L1.69531 4.17053C1.21844 4.36789 1.22338 5.04535 1.70324 5.23555L10.3142 8.65031C11.0708 8.95037 11.9134 8.95037 12.67 8.65031L21.2811 5.23542C21.7608 5.04535 21.766 4.36802 21.2889 4.17066L12.7139 0.622126C11.9316 0.298403 11.0528 0.298403 10.2704 0.622126"
      fill="hsl(from hsl(199 100% 55%) h s 75%)"
    />
    <path
      d="M12.2557 10.5148V19.0455C12.2557 19.4511 12.6648 19.7291 13.042 19.5796L22.6373 15.8551C22.7443 15.8127 22.8361 15.7391 22.9008 15.6439C22.9655 15.5486 23 15.4362 23 15.3211V6.79052C23 6.38477 22.5909 6.10695 22.2137 6.25646L12.6184 9.98089C12.5114 10.0233 12.4196 10.0969 12.355 10.1922C12.2903 10.2874 12.2557 10.3997 12.2557 10.5148Z"
      fill="hsl(from hsl(199 100% 55%) h s 63%)"
    />
    <path
      d="M10.0155 10.9551L7.16783 12.33L6.8787 12.4698L0.867437 15.3501C0.486516 15.5339 3.05176e-05 15.2562 3.05176e-05 14.8329V6.82632C3.05176e-05 6.67317 0.0785547 6.54095 0.18386 6.4415C0.227062 6.39848 0.276073 6.36172 0.329468 6.33229C0.472996 6.2461 0.677887 6.22309 0.852096 6.29199L9.96766 9.90384C10.431 10.0877 10.4674 10.7368 10.0155 10.9551Z"
      fill="hsl(from hsl(199 100% 55%) h s 48%)"
    />
    <path
      d="M10.0155 10.9551L7.16787 12.33L0.183899 6.44137C0.227109 6.3984 0.27612 6.36168 0.329507 6.33229C0.473034 6.2461 0.677925 6.22309 0.852134 6.29199L9.9677 9.90384C10.431 10.0877 10.4674 10.7368 10.0155 10.9551Z"
      fill="black"
      fillOpacity="0.25"
    />
  </svg>
);
